import SearchTab, { Pagination } from '@/components/SeachTab';
import Card from '@/components/Card';
import { Course, CourseEntity, LearnPage } from '@/graphql/generated/graphql';
import { useEffect, useState } from 'react';
import { SearchTabFilters } from '@/services/knowledge-hub/resource.service';
import { getPage } from '@/services/learn/learn.service';
import { fetchCoursesPageable } from '@/services/learn/course.service';
import { joinWithCommaAnd } from '@/utils/array';
import { getAuthors } from '@/utils/learn';
import { navigationLearn } from '../constants';
import Navigation from '@/components/ui/navigation';
import DefaultContentTemplateTags from '@/components/DefaultContentTemplate/Tags';
import AnimatedFadeInComponent from '@/components/AnimatedFadeInComponent';

export default function CoursesSearch() {
  const [courses, setCourses] = useState<CourseEntity[]>([]);
  const [page, setPage] = useState<number>(1);
  const [pageable, setPageable] = useState<Pagination | undefined>();
  const [filters, setFilters] = useState<SearchTabFilters>({});
  const [learnPage, setLearnPage] = useState<LearnPage | null>(null);

  useEffect(() => {
    (async () => {
      const { page: learnPage } = await getPage();
      setLearnPage(learnPage);
      const response = await fetchCoursesPageable(page, filters);
      setCourses(response.courses);
      setPageable(response.pagination);
    })();
  }, [page, filters]);

  return (
    <div className="mb-sh-60">
      <Navigation title="Learn" items={navigationLearn} />
      <SearchTab
        data={courses}
        searchSection={learnPage?.searchSection}
        pageable={pageable}
        onChangePage={(page) => setPage(page)}
        onChangeFilters={(filters) => setFilters(filters)}>
        {courses?.map((courseEntity: CourseEntity) => {
          const course = courseEntity.attributes;

          const cardProps = {
            title: course?.title || '',
            tags: [
              <DefaultContentTemplateTags
                key={course?.title}
                duration={course?.duration || ''}
                tags={['Course']}
                className="!mb-sh-15 !mt-0"
              />,
            ],
            description: course?.description || '',
            author: joinWithCommaAnd(getAuthors(course as Course)?.map((author) => author?.attributes?.name)),
            image: {
              url: course!.thumbnail.data?.attributes?.url || '',
              alternativeText: course!.thumbnail.data?.attributes?.alternativeText || '',
            },
            link: `/learn/course/${course?.slug}`,
          };

          return (
            <AnimatedFadeInComponent key={course!.title!}>
              <Card {...cardProps} key={course!.title!} />
            </AnimatedFadeInComponent>
          );
        })}
      </SearchTab>
    </div>
  );
}
